import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from './../icon';
import { Tag } from './../tag';
import './articleTitle.css';

const ArticleTitle = props => {
  return (
    <div className="article-title">
      <div className="at-buttons">
        {props.allowShare && (
          <div
            className="at-button"
            onClick={ev => {
              ev.preventDefault();
              props.onClickShare();
            }}
          >
            <Icon name="share" />
          </div>
        )}
      </div>
      <div className="title">
        <div className="at-upper-content">
          {props.tags.map(tag => {
            return <Tag key={tag} title={tag} />;
          })}
        </div>
        <div className="title-content">{props.title}</div>
        {props.subtitle || props.extra ? (
          <div style={{ marginTop: 0 }}>
            {props.subtitle ? (
              <span className="subtitle">{props.subtitle}</span>
            ) : null}
            {props.extra ? (
              <span className="extra text-primary">
                <span style={{ color: '#FFFFFF' }}> | </span>
                {props.extra}
              </span>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

ArticleTitle.defaultProps = {
  tags: [],
  onClickShare: () => {},
  allowShare: true,
};

ArticleTitle.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  extra: PropTypes.string,
  tags: PropTypes.array,
  onClickShare: PropTypes.func,
  allowShare: PropTypes.bool,
};

export default ArticleTitle;



// WEBPACK FOOTER //
// ./src/ui/src/component/article/articleTitle.js